import { differenceInYears, format, parseISO, isSameMonth, setMonth } from 'date-fns';

const monthMapEntries: [number, string][] | null = [
  [1, 'January'],
  [2, 'February'],
  [3, 'March'],
  [4, 'April'],
  [5, 'May'],
  [6, 'June'],
  [7, 'July'],
  [8, 'August'],
  [9, 'September'],
  [10, 'October'],
  [11, 'November'],
  [12, 'December'],
];
export const shortMonthMap = new Map<number, string>(
  monthMapEntries.map(([key, value]) => [key, value.substring(0, 3)])
);

export const formatUserDateFromString = (date: string, structure = 'PP') => {
  return format(parseISO(date), structure);
};

export const getDateFromBreakdown = (year: string, month: string, day: string) => {
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

export const getBreakdownFromDate = (date: Date) => {
  return { day: format(date, 'dd'), year: format(date, 'yyyy'), month: format(date, 'MM') };
};

/**
 * Checks whether a given date is over 18 years ago.
 */
export const isOverEighteen = (birthDate: Date) => {
  const diff = differenceInYears(new Date(), birthDate);
  return diff >= 18;
};

export const toISODateString = (date: Date): string => date.toISOString().split('T')[0];

const TODAY = new Date();

const getDateMonth = (month: number) => {
  return setMonth(TODAY, month);
};

export const isSlaveryAndHumanTraffickingPreventionMonth = isSameMonth(TODAY, getDateMonth(0));
export const isBlackHistoryMonth = isSameMonth(TODAY, getDateMonth(1));
export const isWomenHistoryMonth = isSameMonth(TODAY, getDateMonth(2));
export const isChildAbusePreventionMonth = isSameMonth(TODAY, getDateMonth(3));
export const isAsianPacificAmericanMonth = isSameMonth(TODAY, getDateMonth(4));
export const isPrideMonth = isSameMonth(TODAY, getDateMonth(5));
export const isChildhoodCancerAwarenessMonth = isSameMonth(TODAY, getDateMonth(8));
export const isBreastCancerAwarenessMonth = isSameMonth(TODAY, getDateMonth(9));
export const isDisabilityEmploymentAwarenessMonth = isSameMonth(TODAY, getDateMonth(9));
export const isAmericanIndianMonth = isSameMonth(TODAY, getDateMonth(10));
export const isChristmas = isSameMonth(TODAY, getDateMonth(12));
